// GlobalStyles.ts
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Arial', sans-serif;
    color: ${({ theme }) => theme.fontColor || '#333'};
    background-color: ${({ theme }) => theme.bodyBg || '#fff'};
    *, *::before, *::after {
    box-sizing: border-box;
  }
  }
`;